export default __webpack_public_path__ + "static/media/Ethiopia.57636b73.png";